"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require("../../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const getColorCode = props => {
  let color = props.color;

  if (color === "blue") {
    color = "accent";
  } else if (color === "grey") {
    color = "greyLabel";
  }

  const colorCode = _styles.colors[color];

  if (!colorCode) {
    return _styles.colors.accent;
  } else {
    return colorCode;
  }
};

const getBackgroundColorCode = props => {
  let color = props.color;
  color += "LabelFill";

  if (color === "blueLabelFill") {
    color = "accentLabelFill";
  }

  const colorCode = _styles.colors[color];

  if (!colorCode) {
    return _styles.colors.accentLabelFill;
  } else {
    return colorCode;
  }
};

const StyledLabel = _styledComponents2.default.span.withConfig({
  displayName: "Label__StyledLabel",
  componentId: "h3v9p-0"
})(["", " font-size:12px;line-height:15px;letter-spacing:0.5px;font-weight:500;background-color:", ";border-radius:4px;border:", ";color:", ";padding:2px ", "px;"], _styles.defaultBody, props => props.primary ? getBackgroundColorCode(props) : "fff", props => props.primary ? "1px solid transparent" : `1px solid ${getColorCode(props)}`, getColorCode, (0, _styles.calcPadding)(1) + 1);

const Label = (_ref) => {
  let { children, preserveCase = false } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "preserveCase"]);

  return _react2.default.createElement(
    StyledLabel,
    props,
    preserveCase ? children : children.toUpperCase()
  );
};

Label.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  color: _propTypes2.default.oneOf(["blue", "turquoise", "yellow", "red", "teal", "grey"]),
  /**
   * If true, it will leave the label's capitalization as is rather than changing it to all caps
   */
  preserveCase: _propTypes2.default.bool,
  primary: _propTypes2.default.bool
};

exports.default = Label;